import React from "react";
import hitec from "../../../../content/blogs/AirPlayHtv/HITEC/hitec.png";
import hitec_info from "../../../../content/blogs/AirPlayHtv/HITEC/hitec_info.png";
import hitec_2024 from "../../../../content/blogs/AirPlayHtv/HITEC/hitec_2024.png";
import press from "../../../../content/blogs/AirPlayHtv/HITEC/press.png";
import htv_highlight from "../../../../content/blogs/AirPlayHtv/highlight.png";
import highlight from "../../../../content/blogs/AirPlayHtv/highlight.png";
import hitec_showcase from "../../../../content/blogs/AirPlayHtv/HITEC/AirPlay/AirPlay.png";
import hitec_showcase_booth from "../../../../content/blogs/AirPlayHtv/HITEC/AirPlay/HTV.png";
import ise from "../../../../content/blogs/AirPlayHtv/ISE/ISE.png";
import ise_2025 from "../../../../content/blogs/AirPlayHtv/ISE/metric.png";
import ise_showcase from "../../../../content/blogs/AirPlayHtv/ISE/AirPlay/AirPlay.png";
import ise_showcase_booth from "../../../../content/blogs/AirPlayHtv/ISE/AirPlay/Hotel.png";
import digitaltrends from "../../../../content/blogs/AirPlayHtv/media/digitaltrends.png";
import heise from "../../../../content/blogs/AirPlayHtv/media/heise.png";
import tomsguid from "../../../../content/blogs/AirPlayHtv/media/tomsguide.png";
import macrumors from "../../../../content/blogs/AirPlayHtv/media/macrumors.png";
import hospitalitynet from "../../../../content/blogs/AirPlayHtv/media/hospitalitynet.png";
import yonhap from "../../../../content/blogs/AirPlayHtv/media/yonhap.png";
import chosun2 from "../../../../content/blogs/AirPlayHtv/media/chosun2.png";
import hankyung from "../../../../content/blogs/AirPlayHtv/media/hankyung.png";
import etnews from "../../../../content/blogs/AirPlayHtv/media/etnews.png";
import bridgeeconomy from "../../../../content/blogs/AirPlayHtv/media/bridgeeconomy.png";
import meail from "../../../../content/blogs/AirPlayHtv/media/meail.png";
export default {
  React,
  hitec,
  hitec_info,
  hitec_2024,
  press,
  htv_highlight,
  highlight,
  hitec_showcase,
  hitec_showcase_booth,
  ise,
  ise_2025,
  ise_showcase,
  ise_showcase_booth,
  digitaltrends,
  heise,
  tomsguid,
  macrumors,
  hospitalitynet,
  yonhap,
  chosun2,
  hankyung,
  etnews,
  bridgeeconomy,
  meail
};